var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-icon',[_c('img',{attrs:{"src":require("../assets/logo.svg"),"width":"150px","height":"48px","alt":"HubbleStar Logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }